// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__LZTyE","row":"styles_row__3FZcj"};